import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import Container from "@material-ui/core/Container";
import SwipeableViews from "react-swipeable-views";
import { connect } from "react-redux";

// Custom components
import { Modal } from "../general";
import Stepper from "./Stepper";
import CodeInput from "./CodeInput";
import Success from "./Success";
import EmailForm from "./EmailForm";
import DetailsForm from "./DetailsForm";
import {
  userSignUpRequest,
  userValidateCodeRequest,
  checkIfEmailTaken,
  requestCode,
} from "../../redux/actions/authActions.js";

const SignUpModal = ({
  open,
  setOpen,
  openLogin,
  t,
  userSignUpRequest,
  userValidateCodeRequest,
  checkIfEmailTaken,
  requestCode,
}) => {
  // For sliding tabs inside the first slide in the container
  const [slideIndex, setSlideIndex] = useState(0);

  // For sliding the entire container
  const [containerIndex, setContainerIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  // Loading state
  const [signUpLoading, setSignUpLoading] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);
  const [codeLoading, setCodeLoading] = useState(false);

  // Form state
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});

  const [codeErrorMsg, setCodeErrorMsg] = useState("");

  const reset = () => {
    setFormData({});
    setFormErrors({});
    setSlideIndex(0);
    setContainerIndex(0);
  };

  const editFormData = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const editErrors = (valueObj) => {
    setFormErrors({ ...formErrors, ...valueObj });
  };

  const nextSlide = () => {
    setSlideIndex(slideIndex + 1);
    setCodeLoading(false);
    setEmailLoading(false);
    setSignUpLoading(false);
  };

  /// FIXA STRANGE LOADING BUTTON BUG
  const prevSlide = () => {
    setSlideIndex(slideIndex - 1);
    setCodeLoading(false);
    setEmailLoading(false);
    setSignUpLoading(false);
  };

  const trySignUp = () => {
    setSignUpLoading(true);

    userSignUpRequest(formData).then(
      (res) => {
        let data = { email: res.data.email.raw };
        requestCode(data).then(
          (codeRes) => {
            nextSlide();
            if (codeRes.data) {
              // Dumb check to see if we are in production or development mode
              if (codeRes.data.length > 10) {
                console.log("Use this code to log in:");
                console.log(codeRes.data);
              }
            }
          },
          () => {}
        );
      },
      () => {}
    );
  };

  const userValidateEmail = () => {
    setEmailLoading(true);
    checkIfEmailTaken(formData["email"]).then(
      (res) => {
        setEmailLoading(false);
        if (res.data === false) {
          setFormErrors({
            email: "Something went wrong, please try again later.",
          });
        } else {
          setFormErrors({
            email: "This email already has an account, please use another one.",
          });
        }
      },
      (res) => {
        // 404 means that the email isn't taken
        nextSlide();
      }
    );
  };

  const validateCode = (code) => {
    setCodeLoading(true);
    userValidateCodeRequest(formData["email"], code).then(
      () => {
        setContainerIndex(1);
        setIsComplete(true);
        setCodeLoading(false);
      },
      (reason) => {
        console.log(reason);
        setCodeLoading(false);
        setCodeErrorMsg(t("auth.invalidCode"));
      }
    );
  };

  return (
    <Modal
      open={open}
      title={t("auth.signUp")}
      setOpen={(visible) => {
        if (visible === false) {
          reset();
        }
        setOpen(visible);
      }}
      modalProps={{ keepMounted: false }}
      style={{ overflow: "hidden" }}
    >
      <Container component="main" maxWidth="xs" style={{ padding: 0 }}>
        <div>
          <SwipeableViews index={containerIndex}>
            <div style={{ padding: "0 20px" }}>
              <Stepper
                index={slideIndex}
                steps={[
                  t("auth.fillInEmail"),
                  t("auth.addDetails"),
                  t("auth.logIn"),
                ]}
                style={{ margin: 0, padding: "20px 0 10px 0" }}
              />
              <SwipeableViews index={slideIndex}>
                <EmailForm
                  openLogin={openLogin}
                  type="SIGN_IN"
                  userValidateEmail={userValidateEmail}
                  editFormData={editFormData}
                  formData={formData}
                  editErrors={editErrors}
                  formErrors={formErrors}
                  emailLoading={emailLoading}
                  setEmailLoading={setEmailLoading}
                  t={t}
                />
                <DetailsForm
                  trySignUp={trySignUp}
                  goBack={() => prevSlide()}
                  editErrors={editErrors}
                  formErrors={formErrors}
                  editFormData={editFormData}
                  formData={formData}
                  openLogin={openLogin}
                  signUpLoading={signUpLoading}
                />
                <CodeInput
                  validateCode={validateCode}
                  loading={codeLoading}
                  codeErrorMsg={codeErrorMsg}
                  setCodeErrorMsg={setCodeErrorMsg}
                  t={t}
                />
              </SwipeableViews>
            </div>
            <Success isComplete={isComplete} />
          </SwipeableViews>
        </div>
      </Container>
    </Modal>
  );
};

export default connect((state) => state, {
  userSignUpRequest,
  userValidateCodeRequest,
  checkIfEmailTaken,
  requestCode,
})(withTranslation("common")(SignUpModal));
